module.exports = __webpack_public_path__ + "static/media/lua.ea66a601.png";